import s from './style.css';
import Chapter from 'components/Chapter';
import ChartTitle from 'components/ChartTitle';
import AreaComparison from 'components/AreaComparison';
import TextComparison from 'components/TextComparison';
import EmojiGraphFaded from 'components/EmojiGraphFaded';
import InView from 'components/InView';

const Conclusion = ({ copy }) => (
	<Chapter
		onRight
		section={5}
		title={copy.conclusionTitle}
		standFirst={copy.conclusionStandfirst}
	>
		<ChartTitle flush tag="p">
			{copy.conclusionViz1Title}
		</ChartTitle>

		<InView
			render={inView => (
				<EmojiGraphFaded
					data={copy.conclusionViz1}
					emoji={copy.conclusionViz1Emoji}
					emoji2={copy.conclusionViz1Emoji2}
					inView={inView}
				/>
			)}
		/>

		<ChartTitle tag="p">{copy.conclusionText1}</ChartTitle>

		<ChartTitle tag="p">{copy.conclusionText2}</ChartTitle>

		<ChartTitle flush tag="p">
			{copy.conclusionText3}
		</ChartTitle>

		<TextComparison items={[' ', ' ']} />
		<TextComparison
			items={copy.conclusionViz2SubTitle.map(({ title }) => `${title}`)}
		/>

		<InView
			render={inView => (
				<AreaComparison
					isEnd
					data={copy.conclusionViz2}
					masterCircleSize="292"
					masterCirclePercentage="100"
					containerClass={s.viz2Container}
					wrapperClass={s.viz2Wrapper}
					numberClass={s.viz2Number}
					inView={inView}
					color="blueWhite"
					topTight
				/>
			)}
		/>
	</Chapter>
);

export default Conclusion;



// WEBPACK FOOTER //
// ./components/Conclusion/index.js